<template>
    <div>
        <data-table/>
    </div>
</template>
<script>
import DataTable from './components/table/index'
export default {
    name: 'master-thermometer-import',
    components:{
        DataTable,
    }
}
</script>